import * as React from 'react';

export const AgentsScreen = React.lazy(() => import('./AgentsScreen.lazy'));
